import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import { App } from "./App.js";
import { AuthProvider } from "./lib/auth.js";
import { APP_NAME } from "./lib/sport.js";

// Display: Big Shoulders at the weights the scoresheet uses — 700 for small numerals,
// 800 for ranks and ratings, 900 for page titles.
import "@fontsource/big-shoulders-display/700";
import "@fontsource/big-shoulders-display/800";
import "@fontsource/big-shoulders-display/900";
import "@fontsource/public-sans/400.css";
import "@fontsource/public-sans/600.css";
import "@fontsource/public-sans/700.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

// index.html ships a neutral title because one file serves three builds. The real one is
// only known once VITE_SPORT is resolved.
document.title = APP_NAME;

// So "which version are you on" has an answer that does not require a console, a cable, or
// a Mac. The startup handler in index.html prints it when the app fails to come up, and it
// can be read directly from anywhere else.
window.__BUILD_ID__ = __BUILD_ID__;

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);

// Register service worker for PWA support with auto-update
registerSW({ immediate: true });
